import { useState } from 'react';
import { ActionButton, ActionInput } from '../parts/ActionButton.js';
import { ComposerIcon, type FormatName } from './ComposerIcon.js';
import { safeHref } from './editor-dom.js';
export const formats: FormatName[] = ['Bold', 'Italic', 'Underline', 'Strikethrough', 'Bulleted list', 'Numbered list', 'Insert link'];
export function FormatBar({ disabled, onFormat, onRemember, onCloseLink }: {
  disabled: boolean; onFormat: (name: FormatName, href?: string) => void; onRemember: () => void; onCloseLink: () => void;
}) {
  const [link, setLink] = useState(false);
  const [address, setAddress] = useState('');
  const insert = () => {
    const href = safeHref(address);
    if (!href || disabled) return;
    onFormat('Insert link', href); setLink(false); setAddress('');
  };
  return <div className="ch-format-bar">
    <div role="toolbar" aria-label="Format">
      {formats.map(name => <ActionButton type="button" key={name} className="ch-compose-icon" aria-label={name} title={name} disabled={disabled}
        onMouseDown={e => e.preventDefault()} onClick={() => {
          if (name === 'Insert link') { onRemember(); setLink(v => !v); } else onFormat(name);
        }}><ComposerIcon name={name} /></ActionButton>)}
    </div>
    {link ? <div className="ch-link-field">
      <ActionInput autoFocus aria-label="Insert link" placeholder="https://" value={address} disabled={disabled}
        aria-invalid={address.length > 0 && !safeHref(address)} onChange={e => setAddress(e.target.value)} onKeyDown={e => {
          if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); insert(); }
          if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); setLink(false); onCloseLink(); }
        }} />
      <ActionButton type="button" className="ch-compose-icon" aria-label="Insert link" title="Insert link" disabled={disabled || !safeHref(address)} onClick={insert}><ComposerIcon name="Insert link" /></ActionButton>
    </div> : null}
  </div>;
}
